/**
 * Editierbare JTL-Bullet-/Keyword-Mapping-Sektion für EINEN JTL-Channel im
 * Channels-Sub-Tab (C1). Read via useBulletsState (channels-UUID), Save via
 * useChannelBulletsSave (channel_package-id). Ersetzt die frühere „bullets N/A".
 */
import { useBulletsState } from '@/hooks/useBulletsState'
import { useChannelBulletsSave } from '@/hooks/useChannelBulletsSave'
import { ChannelMappedFieldsSection } from './ChannelMappedFieldsSection'
import { ChannelEditorDirtyBar } from './ChannelEditorDirtyBar'
import { BULLET_KEYS } from './channel-constants'

interface Props {
  productId: string
  /** channels.id-UUID — Read (Bullets-GET-Resolver akzeptiert UUID) */
  readChannelId: string
  /** channel_package-id — JTL-Push (wie C1-Beschreibungs-Save) */
  saveChannelId: string
  lang: string
}

export function ChannelBulletsPanel({ productId, readChannelId, saveChannelId, lang }: Props) {
  const bullets = useBulletsState({ productId, channelId: readChannelId, includeBullets: true })
  const { save, isSaving } = useChannelBulletsSave(productId, saveChannelId, readChannelId, lang)

  const changeCount =
    BULLET_KEYS.filter((k) => bullets.bulletsDirty[k]).length + (bullets.keywordsDirty ? 1 : 0)

  const handleSave = () =>
    save({
      bulletFields: bullets.bulletFields,
      bulletsDirty: bullets.bulletsDirty,
      keywordsDirty: bullets.keywordsDirty,
      keywordsValue: bullets.keywordsValue,
    })

  return (
    <>
      <ChannelMappedFieldsSection
        mappedBulletKeys={bullets.mappedBulletKeys}
        bulletFields={bullets.bulletFields}
        onUpdateBullet={bullets.updateBullet}
        keywordsMapped={bullets.keywordsMapped}
        keywordsValue={bullets.keywordsValue}
        onUpdateKeywords={bullets.updateKeywords}
        isMasterChannel={false}
      />
      {bullets.anyDirty && (
        <ChannelEditorDirtyBar
          isDirty={bullets.anyDirty}
          isSaving={isSaving}
          changeCount={changeCount}
          onSave={handleSave}
          onDiscard={bullets.resetBullets}
        />
      )}
    </>
  )
}
